import React, { createContext, useContext, useState, useEffect } from "react";
import {
  localStorageGet,
  localStorageRemove,
  localStorageSet,
} from "../utils/LocalStorageHelper";

interface TourContextType {
  runTour: boolean;
  startTour: () => void;
  stopTour: () => void;
  resetTour: () => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export const TourProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [runTour, setRunTour] = useState(false);
  const [tourCompleted, setTourCompleted] = useState(() => {
    return localStorageGet("tourCompleted") === "true";
  });

  useEffect(() => {
    if (!tourCompleted) {
      startTour();
    }
  }, [tourCompleted]);

  const startTour = () => {
    setRunTour(true);
    setTimeout(() => {
      const targetButton = document.querySelector(
        ".react-joyride__beacon"
      ) as HTMLButtonElement;
      if (targetButton) targetButton.click();
    }, 1);
  };

  const stopTour = () => {
    setRunTour(false);
    setTourCompleted(true);
    localStorageSet("tourCompleted", "true");
  };

  const resetTour = () => {
    setTourCompleted(false);
    localStorageRemove("tourCompleted");
  };

  return (
    <TourContext.Provider value={{ runTour, startTour, stopTour, resetTour }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = (): TourContextType => {
  const context = useContext(TourContext);
  if (!context) throw new Error("useTour must be used within a TourProvider");
  return context;
};
